import { countryCodes } from "~~/i18n";

export const NEWSLETTER_SUBSCRIPTION_WIDGET = {
  [countryCodes.AT]: {
    widgetEnabled: false,
  },
  [countryCodes.BE]: {
    widgetEnabled: false,
  },
  [countryCodes.BG]: {
    widgetEnabled: false,
  },
  [countryCodes.CH]: {
    widgetEnabled: false,
  },
  [countryCodes.CZ]: {
    widgetEnabled: false,
  },
  [countryCodes.DE]: {
    widgetEnabled: false,
  },
  [countryCodes.DK]: {
    widgetEnabled: false,
  },
  [countryCodes.ES]: {
    widgetEnabled: false,
  },
  [countryCodes.FI]: {
    widgetEnabled: false,
  },
  [countryCodes.FR]: {
    widgetEnabled: false,
  },
  [countryCodes.GB]: {
    widgetEnabled: false,
  },
  [countryCodes.GR]: {
    widgetEnabled: false,
  },
  [countryCodes.HR]: {
    widgetEnabled: false,
  },
  [countryCodes.HU]: {
    widgetEnabled: false,
  },
  [countryCodes.IE]: {
    widgetEnabled: false,
  },
  [countryCodes.IT]: {
    widgetEnabled: false,
  },
  [countryCodes.LT]: {
    widgetEnabled: false,
  },
  [countryCodes.NL]: {
    widgetEnabled: false,
  },
  [countryCodes.NO]: {
    widgetEnabled: false,
  },
  [countryCodes.PL]: {
    widgetEnabled: false,
  },
  [countryCodes.PT]: {
    widgetEnabled: false,
  },
  [countryCodes.RO]: {
    widgetEnabled: false,
  },
  [countryCodes.SE]: {
    widgetEnabled: false,
  },
  [countryCodes.SI]: {
    widgetEnabled: false,
  },
  [countryCodes.SK]: {
    widgetEnabled: false,
  },
};
